export default __webpack_public_path__ + "static/media/Helm of the Berserker's Fury.0f0ba5b6.jpg";